import { render, staticRenderFns } from "./TabTransporte.vue?vue&type=template&id=6c6ec3c4&scoped=true"
import script from "./TabTransporte.vue?vue&type=script&lang=js"
export * from "./TabTransporte.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6ec3c4",
  null
  
)

export default component.exports